import {
  LOGOUT_USER,
  GET_COMPANIES,
  ACCEPT_COMPANY,
  SUBMIT_COMPANY,
  REJECT_COMPANY,
} from "../actions/types";
import {
  CANDIDATE_INTERESTED,
  CANDIDATE_NOT_INTERESTED,
} from "../constants/introPriorities";

const initial_state = {
  companies: null,
  intros: null,
};

// step 3 define reducers use module.exports for reducers,
function IntroReducer(state = initial_state, action) {
  switch (action.type) {
    case GET_COMPANIES:
      return {
        ...state,
        companies: action.payload.companies,
        intros: action.payload.intros,
      };

    case ACCEPT_COMPANY: {
      const info = action.payload;
      const index = state.intros.findIndex((i) => i.id === info.intro_id);
      const introToUpdate = state.intros[index];
      introToUpdate.other_data.member_status = CANDIDATE_INTERESTED;
      introToUpdate.other_data.member_interest_blurb = info.interest_blurb;
      introToUpdate.other_data.position_id = info.interest_role;
      return {
        ...state,
        intros: [
          ...state.intros.slice(0, index),
          introToUpdate,
          ...state.intros.slice(index + 1),
        ],
        alert: alert,
      };
    }

    case REJECT_COMPANY: {
      const info = action.payload;
      const index = state.intros.findIndex((i) => i.id === info.intro_id);
      const introToUpdate = state.intros[index];
      introToUpdate.other_data.member_status = CANDIDATE_NOT_INTERESTED;
      return {
        ...state,
        intros: [
          ...state.intros.slice(0, index),
          introToUpdate,
          ...state.intros.slice(index + 1),
        ],
        alert: alert,
      };
    }

    case SUBMIT_COMPANY: {
      const info = action.payload;
      const index = state.intros.findIndex((i) => i.id === info.intro_id);
      const introToUpdate = state.intros[index];
      introToUpdate.other_data.member_status = CANDIDATE_INTERESTED;
      introToUpdate.other_data.member_interest_blurb = info.interest_blurb;
      introToUpdate.other_data.position_id = info.interest_role;
      return {
        ...state,
        intros: [
          ...state.intros.slice(0, index),
          introToUpdate,
          ...state.intros.slice(index + 1),
        ],
        alert: alert,
      };
    }

    case LOGOUT_USER:
      return {
        ...state,
        ...initial_state,
      };
    default:
      return state;
  }
}

export default IntroReducer;



// WEBPACK FOOTER //
// ./src/reducers/introReducer.js